import axios from "axios";

const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export async function createTeacherGroup(payload) {
  return axios
    .post(`${BASE_URL}/api/teacher-groups`, payload)
    .then((response) => response.data);
}

export async function updateTeacherGroup(groupId, payload) {
  return axios
    .put(`${BASE_URL}/api/teacher-groups/${groupId}`, payload)
    .then((response) => response.data);
}

export async function getTeacherGroups(institutionId) {
  return axios
    .get(`${BASE_URL}/api/teacher-groups`, { params: { institutionId } })
    .then((response) => response.data);
}

export async function getTeacherStudents(institutionId) {
  return axios
    .get(`${BASE_URL}/api/teacher-groups/students`, { params: { institutionId } })
    .then((response) => response.data);
}

export async function deleteTeacherGroup(groupId) {
  return axios.delete(`${BASE_URL}/api/teacher-groups/${groupId}`);
}

export async function cloneTeacherGroup(groupId) {
  return axios
    .post(`${BASE_URL}/api/teacher-groups/${groupId}/clone`)
    .then((response) => response.data);
}

export async function addStudentToGroup(groupId, studentId) {
  return axios.post(`${BASE_URL}/api/teacher-groups/${groupId}/students`, {
    studentId,
  });
}

export async function removeStudentFromGroup(groupId, studentId) {
  return axios.delete(`${BASE_URL}/api/teacher-groups/${groupId}/students/${studentId}`);
}

export async function deleteTeacherStudentRelation(studentId, institutionId) {
  return axios.delete(`${BASE_URL}/api/teacher-groups/students/${studentId}/relation`, {
    params: { institutionId },
  });
}

/** Get a student's performance report for the teacher (no ChatGPT, same structure as student report). */
export async function getStudentReport(studentId) {
  return axios
    .get(`${BASE_URL}/api/attempts/summary/student-report/${studentId}`)
    .then((response) => response.data);
}
